import { ReactNode } from "react";
import { Helmet } from "react-helmet-async";

import { DashboardHeaderStyled, DashboardHeaderSuffixStyled, DashboardHeaderTitleStyled } from "./styled";

interface IProps {
    title?: string;
    subTitle?: string;
    titleSuffix?: ReactNode;
    children?: React.ReactNode;
}

const DashboardHeader: React.FC<IProps> = ({ title = "", subTitle = "", titleSuffix, children }) => {
    return (
        <>
            <Helmet>
                <title>Tahseen | {title}</title>
            </Helmet>
            <DashboardHeaderStyled>
                <DashboardHeaderTitleStyled>
                    {title && <h1>{title}</h1>}
                    {subTitle && <p>{subTitle}</p>}
                    {children}
                </DashboardHeaderTitleStyled>
                {titleSuffix ? <DashboardHeaderSuffixStyled>{titleSuffix}</DashboardHeaderSuffixStyled> : null}
            </DashboardHeaderStyled>
        </>
    );
};

export default DashboardHeader;
